import moment from "moment-timezone";
import { MESApiService, getMomentTz } from "../../../services";
import { ShiftsResponse } from "../models/shift-data";

export interface ShiftNavigatorFilterParams {
	productionDate: Date | null;
	shiftId: number;
	assetId?: number | null;
}

export const getShiftsRangeByParameters = async (
	period: string | null,
	Start: Date | null = null,
	End: Date | null = null,
	StartShiftId: number | null = null,
	EndShiftId: number | null = null,
	action: "prev" | "next" | "last" | null = null,
) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetShiftsRangeByParameters]", [
		{
			name: "Period",
			value: period,
		},
		{
			name: "Start",
			value: Start?.toISOString(),
		},
		{
			name: "End",
			value: End?.toISOString(),
		},
		{
			name: "StartShiftId",
			value: StartShiftId,
		},
		{
			name: "EndShiftId",
			value: EndShiftId,
		},
		{
			name: "Action",
			value: action,
		},
	]);
	if (resp.ok) {
		const data = resp.data as ShiftsResponse;

		data.tables[0].rows.map((shift) => {
			shift.Start = moment.utc(shift["Start"]).toDate();
			shift.End = moment.utc(shift["End"]).toDate();
		});

		return {
			ok: true,
			data,
		};
	} else {
		return {
			ok: false,
			message: resp.message!,
		};
	}
};
